export function filterAttributeValues (attribute) {
	if (!attribute || !attribute.values) return []
	return attribute.values
		.filter(c => attribute.options.map(e => e.toLowerCase()).includes(c.toLowerCase()))
		.map(c => c.toLowerCase())
		.filter((c, i, arr) => i === arr.indexOf(c))
}